import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    email: '',
    phone: '',
    partnershipType: '',
    message: '',
    agreeTerms: false,
    subscribe: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const partnershipTypes = [
    { value: 'operator', label: 'Travel Operator Licensing' },
    { value: 'sponsorship', label: 'Experience Sponsorship' },
    { value: 'destination', label: 'Destination Partnership' },
    { value: 'corporate', label: 'Corporate & Brand Experiences' },
    { value: 'technology', label: 'Technology Partnership' },
    { value: 'other', label: 'Other Partnership Inquiry' }
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

//   const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsSubmitting(true);
//         console.log("INSIDE HANDLE SUBMIT: ")

//         // Get selected partnership type label
//         const selectedPartnership = partnershipTypes.find(
//           type => type.value === formData.partnershipType
//         );
//         const partnershipTypeLabel = selectedPartnership ? selectedPartnership.label : formData.pnershipType;

//         // Format the email content
//         const emailSubject = `New Partnership Inquiry: ${formData.company}`;
        
//         const emailBody = `
//       ===============================================
//       MGL EXPERIENCES LTD - PARTNERSHIP INQUIRY
//       ===============================================

//       CONTACT INFORMATION
//       -------------------
//       Full Name: ${formData.firstName} ${formData.lastName}
//       Company: ${formData.company}
//       Email: ${formData.email}
//       Phone: ${formData.phone || 'Not provided'}

//       PARTNERSHIP DETAILS
//       -------------------
//       Partnership Type: ${partnershipTypeLabel}
//       Submission Date: ${new Date().toLocaleDateString('en-GB', {
//         weekday: 'long',
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric'
//       })}
//       Time: ${new Date().toLocaleTimeString('en-GB', {
//         hour: '2-digit',
//         minute: '2-digit'
//       })}

//       MESSAGE
//       -------
//       ${formData.message}

//       PREFERENCES & AGREEMENTS
//       ------------------------
//       Agreed to Terms: ${formData.agreeTerms ? 'Yes' : 'No'}
//       Subscribed to Updates: ${formData.subscribe ? 'Yes' : 'No'}

//       ===============================================
//       This inquiry was submitted via MGL Experiences website.
//       Please respond within 2 business days.
//       ===============================================
//         `.trim();

//         // Create mailto link
//         const mailtoLink = `mailto:contact@mglexperiences.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

//         // Open email client
//         window.location.href = mailtoLink;

//         // Simulate submission success (for UI feedback)
//         setTimeout(() => {
//           console.log('Form submitted:', formData);
//           setIsSubmitting(false);
//           setSubmitSuccess(true);
          
//           // Reset form after success
//           setFormData({
//             firstName: '',
//             lastName: '',
//             company: '',
//             email: '',
//             phone: '',
//             partnershipType: '',
//             message: '',
//             agreeTerms: false,
//             subscribe: false
//           });
//         }, 1000);
// };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    // Your Google Apps Script URL
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwOHaUKO4UoDYJlNPhcmI1ttMIBmxTuuDtX9bCFrPKKLc75Kl3dp2xYVoVODv6B_qiJ/exec';
    
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // Important for Google Apps Script
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    // Success - Google Apps Script always returns 200
    setSubmitSuccess(true);
    setFormData({
      firstName: '',
      lastName: '',
      company: '',
      email: '',
      phone: '',
      partnershipType: '',
      message: '',
      agreeTerms: false,
      subscribe: false
    });
    
  } catch (error) {
    console.error('Error:', error);
    alert('Failed to send. Please email us directly at contact@mglexperiences.com');
  } finally {
    setIsSubmitting(false);
  }
};

// // second
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);

//   try {
//     // Send email directly using Resend
//     await sendPartnershipEmail(formData);
    
//     // Success
//     setSubmitSuccess(true);
    
//     // Reset form
//     setFormData({
//       firstName: '',
//       lastName: '',
//       company: '',
//       email: '',
//       phone: '',
//       partnershipType: '',
//       message: '',
//       agreeTerms: false,
//       subscribe: false
//     });

//   } catch (error) {
//     console.error('Failed to send email:', error);
//     alert('Failed to send message. Please try again or email us directly at contact@mglexperiences.com');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
    
  //   // Simulate API call
  //   setTimeout(() => {
  //     console.log('Form submitted:', formData);
  //     setIsSubmitting(false);
  //     setSubmitSuccess(true);
      
  //     // Reset form after success
  //     setFormData({
  //       firstName: '',
  //       lastName: '',
  //       company: '',
  //       email: '',
  //       phone: '',
  //       partnershipType: '',
  //       message: '',
  //       agreeTerms: false,
  //       subscribe: false
  //     });
  //   }, 1500);
  // };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-gray-900 to-secondary text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-white/10"></div>
        </div>
        <div className="section-container relative">
          <div className="max-w-4xl">
            <div className="inline-flex items-center space-x-2 mb-6">
              <div className="w-3 h-3 bg-primary rounded-full"></div>
              <span className="text-sm font-medium text-primary uppercase tracking-wider">
                B2B Partnership Inquiries
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Start a Conversation
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl">
              Connect with our partnerships team to discuss licensing opportunities, sponsorships, and strategic collaborations.
            </p>
            <div className="flex flex-wrap items-center gap-6">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center mr-3">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <div>
                  <div className="text-sm text-gray-400">Email</div>
                  <div className="font-medium">partners@mglexperiences.com</div>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center mr-3">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <div className="text-sm text-gray-400">Location</div>
                  <div className="font-medium">United Kingdom | Global Operations</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div>
            <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Partnership Inquiry Form</h2>
              
              {submitSuccess ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Message Received</h3>
                  <p className="text-gray-600 mb-6">
                    Thank you for your partnership inquiry. Our team will review your message and respond within 2 business days.
                  </p>
                  <button
                    onClick={() => setSubmitSuccess(false)}
                    className="btn-primary"
                  >
                    Submit Another Inquiry
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="firstName">
                        First Name *
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        required
                        value={formData.firstName}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                        placeholder="John"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="lastName">
                        Last Name *
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        required
                        value={formData.lastName}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                        placeholder="Smith"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="company">
                        Company / Organization *
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        required
                        value={formData.company}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                        placeholder="Your Company Ltd"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="email">
                        Business Email *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                        placeholder="name@company.com"
                      />
                    </div>
                  </div>

                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="phone">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                      placeholder="+44 20 1234 5678"
                    />
                  </div>

                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="partnershipType">
                      Partnership Type *
                    </label>
                    <select
                      id="partnershipType"
                      name="partnershipType"
                      required
                      value={formData.partnershipType}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors appearance-none bg-white"
                    >
                      <option value="">Select partnership type</option>
                      {partnershipTypes.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="message">
                      Your Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      rows="6"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary transition-colors"
                      placeholder="Tell us about your partnership interests, business goals, and how we might collaborate..."
                    ></textarea>
                  </div>

                  <div className="space-y-4 mb-8">
                    <div className="flex items-start">
                      <input
                        type="checkbox"
                        id="agreeTerms"
                        name="agreeTerms"
                        required
                        checked={formData.agreeTerms}
                        onChange={handleChange}
                        className="mt-1 mr-3"
                      />
                      <label htmlFor="agreeTerms" className="text-sm text-gray-600">
                        I agree to the <Link to="/terms-of-use" className="text-primary hover:underline">Terms of Use</Link> and <Link to="/privacy-policy" className="text-primary hover:underline">Privacy Policy</Link>. I understand this is a B2B inquiry form only.
                      </label>
                    </div>
                    <div className="flex items-start">
                      <input
                        type="checkbox"
                        id="subscribe"
                        name="subscribe"
                        checked={formData.subscribe}
                        onChange={handleChange}
                        className="mt-1 mr-3"
                      />
                      <label htmlFor="subscribe" className="text-sm text-gray-600">
                        Subscribe to partnership updates and industry insights (you can unsubscribe at any time)
                      </label>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full btn-primary ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`}
                  >
                    {isSubmitting ? (
                      <span className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Submitting...
                      </span>
                    ) : (
                      'Send Partnership Inquiry'
                    )}
                  </button>
                </form>
              )}
            </div>

            {/* Response Time */}
            <div className="bg-blue-50 rounded-xl p-6">
              <div className="flex items-start">
                <svg className="w-6 h-6 text-blue-600 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Response Time</h4>
                  <p className="text-sm text-gray-600">
                    We aim to respond to all partnership inquiries within 2 business days. For urgent matters, please email partners@mglexperiences.com directly.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Side Information */}
          <div className="space-y-8">
            {/* Partnership Process */}
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Our Partnership Process</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <span className="text-sm font-bold text-primary">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Initial Discussion</h4>
                    <p className="text-sm text-gray-600">We'll schedule a call to understand your partnership goals and business needs.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <span className="text-sm font-bold text-primary">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Needs Assessment</h4>
                    <p className="text-sm text-gray-600">Our team evaluates how our experience IP aligns with your objectives.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <span className="text-sm font-bold text-primary">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Proposal Development</h4>
                    <p className="text-sm text-gray-600">We create a customized partnership proposal with clear terms and expectations.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                    <span className="text-sm font-bold text-primary">4</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Agreement & Onboarding</h4>
                    <p className="text-sm text-gray-600">Finalize partnership terms and begin the onboarding process.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Partnership Types */}
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Types of Partnerships</h3>
              <div className="space-y-4">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-1">Operator Licensing</h4>
                  <p className="text-sm text-gray-600">License our experience IP for regional execution</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-1">Experience Sponsorship</h4>
                  <p className="text-sm text-gray-600">Brand integration within flagship travel experiences</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-1">Destination Partnerships</h4>
                  <p className="text-sm text-gray-600">Collaborate with tourism boards and DMOs</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-1">Corporate Experiences</h4>
                  <p className="text-sm text-gray-600">Custom travel programs for organizations</p>
                </div>
              </div>
            </div>

            {/* Important Notice */}
            <div className="bg-red-50 border-l-4 border-red-500 rounded-r-lg p-6">
              <div className="flex items-start">
                <svg className="w-6 h-6 text-red-600 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Important Notice</h4>
                  <p className="text-sm text-gray-700 mb-2">
                    MGL Experiences Ltd is a B2B company only. We do not sell travel services directly to consumers.
                  </p>
                  <p className="text-sm text-gray-700">
                    All travel execution is handled by licensed operator partners. For consumer travel inquiries, please contact our execution partners directly.
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Alternatives */}
            <div className="bg-gray-900 text-white rounded-2xl p-8">
              <h3 className="text-xl font-bold mb-6">Alternative Contact Methods</h3>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center mr-4">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-sm text-gray-300">Primary Email</div>
                    <div className="font-medium">partners@mglexperiences.com</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center mr-4">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-sm text-gray-300">Mailing Address</div>
                    <div className="font-medium">MGL Experiences Ltd, United Kingdom</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center mr-4">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-sm text-gray-300">Legal Inquiries</div>
                    <div className="font-medium">legal@mglexperiences.com</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}